var exports = {
  "$": "TaillightsCaretVisual__7W-azo",
};

module.exports = exports;
